import { render, staticRenderFns } from "./PartnerPrivacyUSA.vue?vue&type=template&id=3cf84bec&scoped=true"
import script from "./PartnerPrivacyUSA.vue?vue&type=script&lang=js"
export * from "./PartnerPrivacyUSA.vue?vue&type=script&lang=js"
import style0 from "./PartnerPrivacyUSA.vue?vue&type=style&index=0&id=3cf84bec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf84bec",
  null
  
)

export default component.exports